import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './App';
import './index.css';
import { HashRouter } from 'react-router-dom';
import { StyledEngineProvider, ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

const theme = createTheme();
const container = document.getElementById('root');
const root = createRoot(container);

const AppWrapper = () => (
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Provider store={store}>
        <HashRouter>
          <App />
        </HashRouter>
      </Provider>
    </ThemeProvider>
  </StyledEngineProvider>
);

if(window.cordova){
  document.addEventListener('deviceready',

  () => {
    root.render(<AppWrapper />);
  }

  , false);
} else {
  root.render(<AppWrapper />);
}